/**
 * Fornitore / Terza Parte — coreBOS `ThirdParties` (94x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const thirdPartyDescriptor = {
    slug: 'cmp_third_party',
    kind: 'document',
    label: { singular: 'Fornitore / Terza Parte', plural: 'Fornitori e Terze Parti' },
    table: 'compliance_third_party',
    idStrategy: 'sha256',
    fields: [
        { name: 'thirdpartiesname', type: 'text', label: 'Nome Fornitore', required: true },
        { name: 'activity_type', type: 'text', label: 'Tipo Attività' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
        { name: 'criticality', type: 'text', label: 'Criticality' },
        { name: 'assessment_status', type: 'text', label: 'Assessment status' },
        { name: 'outside_eu', type: 'boolean', label: 'Trasferimento extra-UE' }, // pending coreBOS field (vtlib 10)
        { name: 'transfer_mechanism', type: 'text', label: 'Garanzia di trasferimento' }, // pending coreBOS field (vtlib 10)
    ],
    relations: [
        { name: 'relthirdparty_account', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'TeamOutlined', navGroup: 'GDPR' },
};
